export default __webpack_public_path__ + "static/media/rarible-logo.eb6ec361.svg";